import { trackEvent } from './eventTracker'
import { trackFbStandardEvent } from './fbEvents'

interface FlashEvent {
  name?: string
  eventId?: string
}

export function trackPhoenixFlashEvent() {
  const flashEvent = (window as any).FLASH_EVENT as FlashEvent | undefined

  if (!flashEvent || !flashEvent.name) {
    return
  }

  const eventOptions = flashEvent.eventId ? { eventID: flashEvent.eventId } : undefined

  switch (flashEvent.name) {
    case 'oauth_registration_completed':
      trackFbStandardEvent('CompleteRegistration', { registration_method: 'oauth' }, eventOptions)
      trackEvent('registration_completed', { registration_method: 'oauth' })
      break

    case 'email_registration_completed':
      trackFbStandardEvent('CompleteRegistration', { registration_method: 'email' }, eventOptions)
      trackEvent('registration_completed', { registration_method: 'email' })
      break
  }
}
